"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Switch", {
    enumerable: true,
    get: function() {
        return Switch;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useSwitch = require("./useSwitch");
const _renderSwitch = require("./renderSwitch");
const _useSwitchStylesstyles = require("./useSwitchStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const Switch = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useSwitch.useSwitch_unstable)(props, ref);
    (0, _useSwitchStylesstyles.useSwitchStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useSwitchStyles_unstable')(state);
    return (0, _renderSwitch.renderSwitch_unstable)(state);
});
Switch.displayName = 'Switch';
